import script from "./TitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleBar.vue?vue&type=script&setup=true&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=fecf18ac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecf18ac"]])

export default __exports__